import { useToastStore } from '@/store/toastStore';
import type { ToastVariant } from '@/types/common.types';

/**
 * Hook for triggering toast notifications in React components.
 */
export function useToast() {
  const addToast = useToastStore((s) => s.addToast);
  const removeToast = useToastStore((s) => s.removeToast);
  const clearAll = useToastStore((s) => s.clearAll);

  const toast = {
    success: (title: string, description?: string) =>
      addToast({ variant: 'success', title, description, duration: 3000 }),

    error: (title: string, description?: string) =>
      addToast({ variant: 'error', title, description, duration: 5000 }),

    warning: (title: string, description?: string) =>
      addToast({ variant: 'warning', title, description, duration: 5000 }),

    info: (title: string, description?: string) =>
      addToast({ variant: 'info', title, description }),

    custom: (opts: {
      variant: ToastVariant;
      title: string;
      description?: string;
      duration?: number;
    }) => addToast(opts),

    dismiss: (id: string) => removeToast(id),
    dismissAll: () => clearAll(),
  };

  return toast;
}
